import { apiClient, assertOk } from "@/api/generated/client"

export const refreshCache = async () => {
  const { error, response } = await apiClient.POST("/api/Cache/kpis/refresh")
  assertOk(response, error)
}
